<p-table styleClass="p-datatable-sm" [value]="groupedData"
  [style]="{'font-size':'12px'}">
  <ng-template pTemplate="header">
    <tr>
      <th>Duration</th>
      <th>Unit(available days)</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-row>
    <tr>
      <td>{{ row.range }} Days</td>
      <td>
         {{row.items}}
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="footer">
    <tr>
      <td><strong>Total</strong></td>
      <td></td>
    </tr>
  </ng-template>
</p-table>


